import { call, put, takeEvery } from "redux-saga/effects";
import {
    getMaterial,
    addNewMaterial,
    updateMaterial,
    deleteMaterial,
} from "../../api/backend_helper";

import {
    getDataAllSuccess,
    getDataAllFail,
    addMaterial,
    addMaterialSuccess,
    addMaterialFail,
    updateMaterial as updateMaterialAction,
    updateMaterialSuccess,
    updateMaterialFail,
    deleteMaterial as deleteMaterialAction,
    deleteMaterialSuccess,
    deleteMaterialFail,
} from "./slice";

function* getMaterialData(action) {
    try {
        const query = action.payload;
        const data = yield call(getMaterial, query);
        yield put(getDataAllSuccess(data));
    } catch (error) {
        yield put(getDataAllFail(error.message));
    }
}

function* createMaterialSaga(action) {
    try {
        const data = yield call(addNewMaterial, action.payload.data);
        yield put(addMaterialSuccess(data));
    } catch (error) {
        yield put(addMaterialFail(error));
    }
}

function* modifyMaterial(action) {
    try {
        const data = yield call(
            updateMaterial,
            action.payload.data.id,
            action.payload.data
        );
        yield put(updateMaterialSuccess(data));
    } catch (error) {
        yield put(updateMaterialFail(error.message));
    }
}

function* removeMaterial(action) {
    try {
        yield call(deleteMaterial, action.payload.id);
        yield put(deleteMaterialSuccess(action.payload.id));
    } catch (error) {
        yield put(deleteMaterialFail(error.message));
    }
}

function* MaterialsSaga() {
    yield takeEvery("material/getDataAll", getMaterialData);
    yield takeEvery(addMaterial.type, createMaterialSaga);
    yield takeEvery(updateMaterialAction.type, modifyMaterial);
    yield takeEvery(deleteMaterialAction.type, removeMaterial);
}

export default MaterialsSaga;
